<template lang="pug">
  v-card.map-filter-panel(:class="{ 'panel-disabled': disabled }", elevation="4", width="300")
    v-card-title.py-2(@click="!disabled && (colapsado = !colapsado)", style="cursor: pointer")
      v-icon.mr-2(small) mdi-filter-outline
      span.subtitle-1.font-weight-bold(v-if="!colapsado") Filtros
      v-spacer
      v-icon(small) {{ colapsado ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
    v-expand-transition
      div(v-show="!colapsado")
        v-divider
        v-card-text.pa-3
          v-autocomplete(
            v-for="(filtro, indice) in filtros",
            :key="filtro.campo",
            v-model="selecoes[filtro.campo]",
            :items="opcoesDosFiltros[filtro.campo]",
            :label="filtro.label",
            :class="{ 'mt-3': indice > 0 }",
            multiple,
            clearable,
            dense,
            outlined,
            hide-details,
            :prepend-inner-icon="filtro.icone || 'mdi-filter'",
            no-data-text="Nenhum item encontrado",
            @change="onFiltroChange(filtro.campo, indice)"
          )
            template(v-slot:selection="{ index }")
              span.caption(v-if="index === 0") {{ selecoes[filtro.campo].length }} selecionado(s)
</template>

<script>
export default {
  name: "MapFilter",

  props: {
    filtros: {
      type: Array,
      default: () => []
    },
    dados: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      colapsado: true,
      selecoes: {}
    };
  },

  computed: {
    opcoesDosFiltros() {
      const resultado = {};
      let dadosFiltrados = this.dados;

      for (const filtro of this.filtros) {
        const valoresUnicos = [
          ...new Set(dadosFiltrados.map(d => d[filtro.campo]).filter(v => v != null && v !== ""))
        ];

        if (filtro.ordenarPor === "versao") {
          valoresUnicos.sort((a, b) => {
            const pa = a.split(".").map(Number);
            const pb = b.split(".").map(Number);
            for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
              if ((pb[i] || 0) !== (pa[i] || 0)) return (pb[i] || 0) - (pa[i] || 0);
            }
            return 0;
          });
        } else if (filtro.ordenarPor) {
          const sortMap = {};
          for (const d of dadosFiltrados) {
            const val = d[filtro.campo];
            if (val != null && val !== "" && !(val in sortMap)) {
              sortMap[val] = d[filtro.ordenarPor];
            }
          }
          valoresUnicos.sort((a, b) => (Number(sortMap[a]) || 0) - (Number(sortMap[b]) || 0));
        } else {
          valoresUnicos.sort();
        }

        const prefixMap = {};
        if (filtro.prefixoCampo) {
          for (const d of dadosFiltrados) {
            const val = d[filtro.campo];
            if (val != null && val !== "" && !(val in prefixMap)) {
              prefixMap[val] = d[filtro.prefixoCampo];
            }
          }
        }

        resultado[filtro.campo] = valoresUnicos.map(v => ({
          text: filtro.prefixoCampo && prefixMap[v] != null ? `${prefixMap[v]} - ${v}` : String(v),
          value: v
        }));

        const selecao = this.selecoes[filtro.campo];
        if (selecao && selecao.length > 0) {
          dadosFiltrados = dadosFiltrados.filter(d => selecao.includes(d[filtro.campo]));
        }
      }

      return resultado;
    }
  },

  watch: {
    disabled(val) {
      if (val) {
        this.colapsado = true;
      }
    },
    filtros: {
      immediate: true,
      handler(novosFiltros) {
        for (const f of novosFiltros) {
          if (!(f.campo in this.selecoes)) {
            this.$set(this.selecoes, f.campo, []);
          }
        }
      }
    }
  },

  methods: {
    fecharPainel() {
      this.colapsado = true;
    },

    onFiltroChange(campo, indice) {
      for (let i = indice + 1; i < this.filtros.length; i++) {
        this.$set(this.selecoes, this.filtros[i].campo, []);
      }
      this.$emit("update:filtros", { ...this.selecoes });
    }
  }
};
</script>

<style scoped>
.map-filter-panel {
  position: absolute;
  bottom: 10px;
  left: 10px;
  z-index: 1000;
}

.panel-disabled {
  opacity: 0.5;
  pointer-events: none;
}
</style>
